import Scroller from "../elements/HomeV2/PartsV2/Scroller";

export default Scroller;